import React from 'react'

const ContentUI = ({context, content, contentList, contentCode}) =>
  <React.Fragment>
    {
      content &&
      <span dangerouslySetInnerHTML={{__html: content}}>
      </span>
    }
    {
      contentList && contentList.filter(content => content.ContentCode === contentCode).length > 0 &&
      <span dangerouslySetInnerHTML={{__html: ((contentList.filter(content => content.ContentCode === contentCode))[0].Value)}}>
      </span>
    }
  </React.Fragment>

export default ContentUI
